import React from "react";
import brand from "../db/brand";
const Channels = () => (
  <div className="channels">
    {brand.channels.map((c) => <span key={c} className="ch">{c}</span>)}
  </div>
);
export default Channels;
